
export const USER_ROLES = {
  ADMIN: 1,
  AUDIOLOGIST: 2,
  DISTRIBUTOR:3,
  SALES:4
};

export const GENDER = {
  MALE: 1,
  FEMALE: 2,
  OTHER: 3,
};
export const actions = {
  SIGN_IN: 'SIGN_IN',
  SET_USER: 'SET_USER',
  SIGN_OUT: 'SIGN_OUT',
  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  UPDATE_USER_DATA: 'UPDATE_USER_DATA',
  SET_USER_LAST_READ_NOTIFICATION: 'SET_USER_LAST_READ_NOTIFICATION',
  CALL_SNACKBAR_DATA: "CALL_SNACKBAR_DATA",
  SET_NOTIFICATION_DATA: "SET_NOTIFICATION_DATA",
  NOTIFICATION_READ: "NOTIFICATION_READ",

  FETCH_DATA_VENDER_LODING: "FETCH_DATA_VENDER_LODING",
  FETCH_DATA_VENDER_DATA: "FETCH_DATA_VENDER_DATA",
  FETCH_DATA_VENDER_DELETE: "FETCH_DATA_VENDER_DELETE",

  FETCH_DATA_RAWMATERIAL_LODING: "FETCH_DATA_RAWMATERIAL_LODING",
  FETCH_DATA_RAWMATERIAL_DATA: "FETCH_DATA_RAWMATERIAL_DATA",
  FETCH_DATA_RAWMATERIAL_DELETE: "FETCH_DATA_RAWMATERIAL_DELETE",

  LEFT_THERAPY:"LEFT_THERAPY",
  RIGHT_THERAPY:"RIGHT_THERAPY",
  VOLUME_LEVELS :"VOLUME_LEVELS",

}

export const NOTIFICATION_TYPE = {
  general: "general",
  lead: "lead",
};

export const SNACK_BAR_VARIETNS = {
  error: "error",
  suceess: "success",
  info: "info",
  warning: "warning",
};

export const DAY_WEEK_MONTH ={
  DAY:"day",
  WEEK:"week"
}

export const CREATE_CUSTOM_THERAPY={
  ENVIRONMENTAL:0,
  MUSIC:1,
  THERAPEUTIC:2
}
